import StaticTemplate from './StaticTemplate';

export default StaticTemplate;
